import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'
import PropTypes from 'prop-types'

import { SearchPanelContainer } from '@components/Search'
import FilterGroup from '@components/FilterGroup'
import MonthYearPicker from '@components/MonthPicker/MonthYearPicker'
import { Autocomplete } from '@components/Autocomplete'
import { stringifyYearMonth } from '@atheneum/api/dist/lib'
import Spinner from '@components/spinner'
import Error from '@components/Error/NoContent'

class PerformanceFilterPanel extends Component {
  static propTypes = {
    employeeList: PropTypes.object,
    performanceStore: PropTypes.object
  }

  componentDidMount () {
    this.props.performanceStore.loadEmployeeList()
  }

  renderError (error) {
    if (error) return <Error />
  }

  renderLoader () {
    return <Spinner />
  }

  filterByEmployee (id) {
    const { performanceStore } = this.props
    performanceStore.query.employeeId = id
    performanceStore.filter()
  }

  filterByMonth (date) {
    if (!date) return
    const { performanceStore } = this.props
    const formattedDate = stringifyYearMonth(date)
    performanceStore.query.month = formattedDate
    performanceStore.filter()
  }

  onClearSearch = () => {
    this.props.performanceStore.clearSearch()
  }

  render () {
    const { query, employeeList, loadList, error } = this.props.performanceStore
    if (error) {
      return this.renderError(error)
    }
    if (loadList) {
      return this.renderLoader()
    }

    return (
      <SearchPanelContainer
        extrathin
        searchTitle='Filter'
        onClearSearch={this.onClearSearch}
      >
        <FilterGroup label='Select employee'>
          <Autocomplete
            valueIsId
            showResultsOnEmptyInput
            value={query.employeeId}
            itemToString={item => item && item.fullName}
            options={[{ id: '', fullName: 'All' }].concat(toJS(employeeList))}
            onChange={employee => {
              if (!employee) return
              this.filterByEmployee(employee.id)
            }}
          />
        </FilterGroup>
        <FilterGroup label='Select month'>
          <MonthYearPicker
            monthAndYear={query.month}
            onChange={value => {
              this.filterByMonth(value)
            }}
          />
        </FilterGroup>
      </SearchPanelContainer>
    )
  }
}

export default inject('performanceStore')(observer(PerformanceFilterPanel))
